import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type Payment from 'modules/payroll_bundle/store/models/Payment'

interface Props {
  onClose: () => void
  payment: Payment
}

const DeletePaymentModal = ({ payment, onClose }: Props) => {
  const onConfirm = async () => {
    const { success } = await asyncAction(() => payment.destroy())

    if (success) onClose()
  }

  return (
    <Modal
      title={i18n.t('payroll_bundle.results_payments.payments.delete_payment_modal.title')}
      description={i18n.t(
        'payroll_bundle.results_payments.payments.delete_payment_modal.description'
      )}
      illustration="delete"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} type="primary">
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default DeletePaymentModal
